<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3"></div>
        <div class="col-16 px-3 py-3 mb-5">
          <div class="col d-column">
            <h1
              class="title pt-2 mb-0"
              v-text="$ml.get('dashCreatNdaTitle')"
            ></h1>
            <h1 class="title">
              <span
                v-text="$ml.get('dashCreatNdaSubTitle')"
                class="pb-2"
              ></span>
            </h1>
            <div class="card mb-3">
              <div class="card-header" v-text="$ml.get('whatIsNdaHeader')">
                Qual é a função de um NDA?
              </div>
              <div class="card-body">
                <div>
                  <div class="card-body footer-helper pb-2 d-flex flex-column">
                    <p v-text="$ml.get('cautionNDA1')">
                      Ao redigir o NDA da sua empresa certifique-se de que ele
                      contemple os seguintes itens:
                    </p>
                    <ul style="color: #717171;">
                      <li v-text="$ml.get('cautionNDA2')">
                        conter ao menos uma cláusula com a penalidade, em caso
                        de descumprimento;
                      </li>
                      <li v-text="$ml.get('cautionNDA3')">
                        informar as partes que assumem aquele compromisso;
                      </li>
                      <li v-text="$ml.get('cautionNDA4')">
                        conter prazo de validade;
                      </li>
                      <li v-text="$ml.get('cautionNDA5')">
                        detalhar especificamente sobre o que se refere aquele
                        NDA, pois informações genéricas e ambíguas
                        descaracterizam o documento legal.
                      </li>
                      <li>
                        {{ $ml.get("cautionNDA6") }} 
                        <b style="color: #730BA9;">@nome_do_especialista</b>
                        {{ $ml.get("cautionNDA7") }}
                      </li>
                    </ul>
                    <p>
                      <br />
                      <b style="color: #730BA9;" v-text="$ml.get('cautionNDA8')"
                        >O modelo de NDA abaixo é ilustrativo. Certifique-se de
                        informar corretamente os dados da sua empresa ao redigir
                        o contrato de confidencialidade.</b
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-no mb-3">
              <div class="card-body">
                <div class="d-column flex-row">
                  <div
                    class="h-form h-profile-lg d-flex flex-column pb-3 align-items-center no"
                  >
                    <div class="d-flex align-self-start">
                      <div
                        class="position-relative align-self-center d-flex align-items-center align-self-center"
                      >
                        <div
                          class="circle-number d-flex justify-content-center align-items-center"
                        >
                          <span>1</span>
                        </div>
                      </div>
                      <div class="pl-3 d-flex">
                        <div class="align-self-start mt-1">
                          <h2 class="size-1_4 m-0 pb-1">
                            <strong v-text="$ml.get('terms')">Termos</strong>
                          </h2>
                          <p class="d-flex align-items-center">
                            <span
                              class="align-self-center"
                              v-text="$ml.get('dashCreatNdaWriteTerms')"
                            >
                              Redija os termos do seu contrato de
                              confidencialidade e suas peculiaridades.
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-primary"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="card card-body ml-3 pl-3 d-flex w-100 pr-3">
                        <form>
                          <div class="col">
                            <svg
                              v-show="!htmlText"
                              @click="viewHtml()"
                              width="24"
                              height="24"
                              class="ico-view-report"
                            >
                              <image
                                xlink:href="../../../assets/icons/eye.svg"
                                width="24"
                                height="24"
                              />
                            </svg>
                            <svg
                              v-show="htmlText"
                              @click="htmlText = ''"
                              width="24"
                              height="24"
                              class="ico-view-report"
                            >
                              <image
                                xlink:href="../../../assets/icons/eye-slash.svg"
                                width="24"
                                height="24"
                              />
                            </svg>
                            <textarea
                              v-show="!htmlText"
                              class="form-control-textarea w-100 text-are-mark"
                              :value="nda"
                              @input="$emit('update:nda', $event.target.value)"
                              ref="textarea"
                              @keyup="controlTextArea()"
                              @focus="controlTextArea()"
                              placeholder=""
                            >
                            </textarea>
                            <div
                              v-show="htmlText"
                              class="form-control w-100 h-100"
                              v-html="htmlText"
                            ></div>
                          </div>

                          <transition name="fade">
                            <label
                              v-if="errorNda"
                              class="lblError"
                              v-text="
                                $ml
                                  .with('f', 3)
                                  .with('l', '300.000')
                                  .get('programNdaMustBeBetweenAndCharacters')
                              "
                              >O conteúdo do NDA deve ter entre 3 e 300.000
                              caracteres!</label
                            >
                            <label
                              v-if="ndaMaxLengt"
                              class="lblError"
                              v-text="
                                $ml
                                  .with('300.000')
                                  .get('maximumLengthIsCharacters')
                              "
                              >Tamanho máximo é de 300.000 caracteres</label
                            >
                          </transition>
                        </form>
                      </div>
                    </div>
                    <div class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>
                    <div class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-5"></span>
                      </div>
                    </div>
                    <div class="d-flex align-self-start">
                      <div
                        class="position-relative align-self-center d-flex align-items-center align-self-center"
                      >
                        <div
                          class="circle-number d-flex justify-content-center align-items-center"
                        >
                          <span>2</span>
                        </div>
                      </div>
                      <div class="pl-3 d-flex">
                        <div class="align-self-start mt-1">
                          <h2 class="size-1_4 m-0 pb-1">
                            <strong v-text="$ml.get('conclude')"
                              >Concluir</strong
                            >
                          </h2>
                          <p class="d-flex align-items-center">
                            <span
                              class="align-self-center"
                              v-text="$ml.get('haveYouRevised')"
                            >
                              Revisou seu modelo? Então pronto!
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-success"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span class="pb-5"></span></div>
                      </div>
                      <div class="pl-3 d-flex w-100 align-items-center">
                        <div
                          class="d-flex flex-row justify-content-between align-items-start w-100"
                        >
                          <button
                            @click="saveNda()"
                            :disabled="loadingBtn"
                            class="btn"
                          >
                            <Spinner v-show="loadingBtn" />
                            <span
                              v-show="!loadingBtn"
                              v-text="$ml.get('saveNda')"
                              >Salvar contrato de confidencialidade</span
                            >
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import ProgramService from "../../../services/program.service";

export default {
  name: "create-nda",

  data() {
    return {
      ndaMaxLengt: false,
      nda: "",
      name: "",
      company_name: "",
      programId: "",
      htmlText: "",
      errorNda: false,
      loadingBtn: false,
    };
  },
  watch: {
    typeProgram: function() {
      if (this.typeProgram.id) this.$emit("verify-Plan", this.typeProgram.id);
    },

    slug(text) {
      if (text) this.slug = text.replace(/[^a-zA-Z0-9-]*$/i, "");
    },
  },
  created() {
    this.programId = this.$route.fullPath.split("?")[1];
  },
  mounted() {
    this.loadNdaListAndVerifyIfProgramCanAcceptNDA();
    this.loadNda();
    const { textarea } = this.$refs;
    textarea.style.height = "480px";
  },
  methods: {
    async loadNdaListAndVerifyIfProgramCanAcceptNDA() {
      this.loading = true;
      ProgramService.getNdaList().then((response) => {
        if (response.data) {
          const program_list = response.data;
          const id = this.$route.fullPath.split("?")[1];
          const programIdList = program_list.map((item) => item._id);
          if (!programIdList.includes(id)) {
            this.$router.push("/dashboard");
          }
        }
        this.loading = false;
      });
    },

    viewHtml() {
      this.htmlText = "";
      this.htmlText = this.$utils.convertMarkedOld(
        this.nda,
        [],
        this.company_name,
        this.name
      );
    },
    controlTextArea() {
      const { textarea } = this.$refs;
      textarea.style.height =
        textarea.scrollHeight < 800 ? textarea.scrollHeight + "px" : 800 + "px";
      this.nda = textarea.value;
      if (textarea.value.length > 300000) {
        this.nda = textarea.value.substring(0, 300000);
        this.ndaMaxLengt = true;
      } else {
        this.ndaMaxLengt = false;
      }
    },
    async saveNda() {
      var self = this;

      this.loadingBtn = true;

      ProgramService.postNda({
        programId: this.programId,
        description: this.nda,
      }).then(
        (response) => {
          this.loadingBtn = false;
          if (response.data) {
            Swal.fire({
              icon: "success",
              title: self.$ml.get("NdaCreated"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              this.$router.push("/program/nda");
            });
          }
        },
        () => {
          this.loadingBtn = false;
          Swal.fire({
            icon: "info",
            title: self.$ml.get("unableToCompleteThisRequest"),
            showConfirmButton: false,
            timer: 3000,
          });
        }
      );
    },
    async loadNda() {
      ProgramService.getNda(this.programId).then(
        (response) => {
          if (response.data.name) {
            this.name = response.data.name;
          } else {
            this.name = "João Silva";
          }

          if (response.data.company_name) {
            this.company_name = response.data.company_name;
          } else {
            this.company_name = "BUGHUNT";
          }

          if (response.data.description) {
            this.nda = response.data.description;
          } else {
            this.nda =
              "***MODELO DE ACORDO DE CONFIDENCIALIDADE***\n" +
              "\n" +
              "\n" +
              "Pelo presente instrumento particular, as partes, de um lado:\n" +
              "\n" +
              "\n" +
              "***INFORME_O_NOME_DA_SUA_EMPRESA***, sociedade por ações inscrita no CNPJ sob o nº INFORME_O_CNPJ_DA_SUA_EMPRESA, com sede na cidade e estado de INFORME_O_ENDERECO_DA_SUA_EMPRESA, neste ato representada na forma de seu Estatuto Social em vigor, doravante denominada simplesmente ***“PARTE REVELADORA”***;e de outro lado, ***@nome_do_especialista***, (qualificação completa), doravante simplesmente denominada ***“PARTE RECEPTORA”***.\n" +
              "\n" +
              "\n" +
              "* ***CONSIDERANDO QUE:*** A ***PARTE REVELADORA*** é @descricao_das_atividades_principais_da_sua_empresa;\n" +
              "\n" +
              "\n" +
              "* A ***PARTE RECEPTORA*** é um especialista em cibersegurança e tem interesse em participar de Programas da ***PARTE REVELADORA***, hipótese em que precisará ter acesso a informações confidenciais relativas à ***PARTE REVELADORA*** e seus clientes, as quais deverão ser tratadas com o devido sigilo e confidencialidade.\n" +
              "\n" +
              "\n" +
              "Assim, resolvem as Partes, de comum acordo, celebrar o presente Acordo de Confidencialidade (“Acordo”) que será regido de acordo com as seguintes cláusulas e condições:\n" +
              "\n" +
              "\n" +
              "1. Toda e qualquer informação revelada pela ***PARTE REVELADORA*** para a ***PARTE RECEPTORA***, seja em forma escrita, verbal, visual, eletrônica ou tangível, estando ou não designada expressamente como confidencial, será sujeita aos termos e condições dispostos no presente instrumento e considerada “Informação Confidencial”.\n" +
              "\n" +
              "\n" +
              "2. Para evitar dúvidas, o termo “Informações Confidenciais” também significa, sem se limitar a, qualquer informação comercial, didática, técnica, financeira, jurídica, econômica, estratégica, ou de outra natureza, segredo de negócio, ou informação científica, know-how, códigos-fonte, repositórios de código, conjunto de códigos de programação, designs, planos, desenhos, dados, anotações, documentos, relatórios, observações, materiais, documentos, informações de clientes, parceiros e/ou colaboradores, anotações, além de quaisquer vídeos, resultados analíticos e recomendações, sejam de natureza jurídica, técnica, econômica ou outra, resumos, extratos, sinopses, ou cópias que contenham, ainda que em parte, qualquer Informações Confidenciais, sejam tais informações recebidas pela ***PARTE RECEPTORA*** por escrito, oralmente, por observação ou, ainda, por meio de dedução ou investigação das Informações Confidenciais reveladas pela ***PARTE REVELADORA***, incluindo o resultado, processos e procedimentos relativos aos Programas\n" +
              "\n" +
              "\n" +
              "3. A ***PARTE RECEPTORA*** não poderá, em nenhuma hipótese, revelar as Informações Confidenciais a terceiros.\n" +
              "\n" +
              "\n" +
              "4. Em relação à obrigação de confidencialidade disposta neste instrumento, a ***PARTE RECEPTORA*** concorda que:\n" +
              "* Manterá a integral confidencialidade das Informações Confidenciais;\n" +
              "* Não utilizará as Informações Confidenciais, direta ou indiretamente, senão para possibilitar a consecução dos objetivos definidos nos Programas;\n" +
              "* Não revelará as Informações Confidenciais, em qualquer hipótese, a quaisquer terceiros; e\n" +
              "* Informará imediatamente a ***PARTE REVELADORA*** sobre a revelação ou uso não autorizado de quaisquer Informações Confidenciais.\n" +
              "\n" +
              "\n" +
              "5. Caso venha a ser solicitado ou exigido da ***PARTE RECEPTORA***, por qualquer autoridade governamental ou judiciária competente, a revelação de Informações Confidenciais, a ***PARTE RECEPTORA*** deverá, imediatamente, (i) notificar por escrito a ***PARTE REVELADORA*** sobre tal ocorrência para que seja possível a defesa de seus interesses, e (ii) cooperar com a ***PARTE REVELADORA*** nos esforços para obtenção de medida cautelar ou outro remédio para a manutenção do caráter confidencial da Informações Confidenciais requerida. Se a medida cautelar ou outro remédio não for obtido pelas partes, a ***PARTE RECEPTORA*** fornecerá somente a parcela das Informações Confidenciais que seja estritamente necessária para cumprimento da ordem ou determinação legal, bem como envidará seus maiores esforços para que as Informações Confidenciais reveladas sejam tratadas sob sigilo pelos receptores.\n" +
              "\n" +
              "\n" +
              "6. A ***PARTE RECEPTORA*** tem ciência de que as Informações Confidenciais não podem ser, em qualquer hipótese reveladas, parcial ou integralmente, a terceiros. Não obstante, a ***parte receptora*** não terá obrigação de preservar o sigilo relativo a qualquer informação que, por meio de válido instrumento por escrito:Ateste que era de seu legítimo conhecimento anteriormente à revelação pela ***PARTE REVELADORA***, não estando sujeita a nenhuma obrigação de ser mantida em sigilo;Esteja ou venha a tornar-se publicamente disponível por meio diverso que não a revelação não autorizada pela ***PARTE RECEPTORA***; e Seja recebida pela ***PARTE RECEPTORA***, sem restrições, de terceiros que estejam autorizados a divulgar a informação.\n" +
              "\n" +
              "\n" +
              "7. Nenhuma disposição deste instrumento será interpretada como uma outorga de licença ou propriedade implícitas ou de qualquer outra natureza, nem direitos de qualquer espécie sobre as Informações Confidenciais ou direitos de propriedade intelectual da ***PARTE REVELADORA***. Nenhum direito de uso de quaisquer das marcas, registradas ou não, serviços de marca ou patente é concedido por meio do presente instrumento pela ***PARTE REVELADORA***.\n" +
              "\n" +
              "\n" +
              "8. Mediante solicitação da ***PARTE REVELADORA***, a ***PARTE RECEPTORA*** deverá imediatamente, mediante recibo, destruir ou devolver, conforme indicação da ***PARTE REVELADORA***, todas as Informações Confidenciais que estiverem sob sua guarda, incluindo, mas não se limitando a, documentos, análises ou quaisquer outros materiais escritos que forem entregues ou gerados em razão dos termos e condições consubstanciados no presente instrumento, sem que sejam guardadas cópia de tais informações.\n" +
              "\n" +
              "\n" +
              "9. O presente Acordo de Confidencialidade entra em vigor a partir da data de sua assinatura e permanecerá vigente por 10 (dez) anos contados da última divulgação de Informações Confidenciais.\n" +
              "\n" +
              "\n" +
              "10. Nenhuma alteração ao presente Acordo será válida se não feita por meio de aditivo contratual, devidamente assinada pelas partes.\n" +
              "\n" +
              "\n" +
              "11. Este Acordo e os direitos e obrigações concedidos e assumidos pelas partes não poderão ser cedidos ou transferidos, total ou parcialmente, pela ***PARTE RECEPTORA***, sem o prévio consentimento por escrito da ***PARTE REVELADORA***.\n" +
              "\n" +
              "\n" +
              "12. A ***PARTE RECEPTORA*** tem conhecimento e concorda que a ***PARTE REVELADORA***: (i) não garante, em qualquer hipótese, expressa ou implicitamente, a exatidão, precisão e/ou completude das Informações Confidenciais; e (ii) não tem qualquer responsabilidade, direta ou indireta, perante a ***PARTE RECEPTORA***, em relação ao eventual uso das Informações Confidenciais.\n" +
              "\n" +
              "\n" +
              "13. A ***PARTE RECEPTORA*** declara e concorda que a violação do presente Acordo poderá causar à ***PARTE REVELADORA*** perdas, danos e prejuízos irreparáveis. Desta forma, em caso de violação de qualquer disposição do presente Acordo pela ***PARTE RECEPTORA***, esta deverá indenizar a ***PARTE REVELADORA*** por quaisquer perdas, danos e prejuízos causados direta ou indiretamente, incluindo danos indiretos, consequenciais, incidentais, especiais e lucros cessantes, sendo que a indenização só será devida após decisão judicial final transitada em julgado.\n" +
              "\n" +
              "\n" +
              "14. Caso qualquer disposição do presente Acordo torne-se inválida ou ineficaz, as demais disposições permanecerão plenamente válidas e eficazes na medida permitida por lei.\n" +
              "\n" +
              "\n" +
              "15. Este Acordo é regulado pelas leis brasileiras e as partes elegem o foro da comarca de São Paulo, Estado de São Paulo, para dirimir quaisquer questões que dele eventualmente venham decorrer, renunciando a qualquer outro por mais privilegiado que seja.\n" +
              "\n" +
              "\n" +
              "***INFORME_O_NOME_DA_SUA_EMPRESA***\n";
          }
        },
        () => {
          this.loadingBtn = false;
          Swal.fire({
            icon: "info",
            title: self.$ml.get("unableToCompleteThisRequest"),
            showConfirmButton: false,
            timer: 3000,
          });
        }
      );
    },
    // async verifyPlan() {
    //   var self = this;
    //   Swal.fire({
    //     icon: "info",
    //     html: `<h3 class="mb-2">${self.$ml.get("cantSetNdaTitle")}<h3>
    //     <h5 class="mb-2">
    //       ${self.$ml.get(
    //         "toAddMoreUsersCheck"
    //       )} <a href="/account?plans">${self.$ml.get("here")}</a>
    //     </h5>`,
    //     showConfirmButton: false,
    //     timer: 10000,
    //   });
    // },
  },
};
</script>
